export const SESSION_IDLE_TIMEOUT_MS = 30 * 60 * 1000;
export const SESSION_ACTIVITY_SYNC_INTERVAL_MS = 5 * 1000;
export const SESSION_LAST_ACTIVE_AT_KEY = 'expertLastActiveAt';
export const SESSION_ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart', 'focus'];
